import { EventEmitter, Injector }                                                           from '@angular/core';
import { WaitingForResponse }                                                               from '@cs/common/utils';
import { AuditTrailAuditEntry }                                                             from '@cs/components/audit-trail';
import { BottomBarQuery, BottomBarRequestActions, BottomBarService, CsButtonBarComponent }  from '@cs/components/cs-bottom-button-bar';
import { DynamicButtonBarClickedEventArgs, DynamicButtonRegistration, DynamicButtonsAgent } from '@cs/components/cs-dynamic-button-bar';
import { DashboardPanelComponentBase }                                                      from '@cs/components/shared';
import { DataDescribed, getErrorMessagesFromValidators }                                    from '@cs/core/generate';
import { tap }                                                                              from 'rxjs/operators';


export class DefaultDashboardPopupDynamicButtonsAgent extends DynamicButtonsAgent {

	setupButtons(): void {


		this.addButton(DynamicButtonRegistration
						   .createClientButton({
												   buttonId:      'Save',
												   buttons:       [
													   {
														   label:     'Save',
														   name:      'save',
														   btnClass:  'btn--primary btn-md m-0',
														   iconClass: 'mdi mdi-content-save'
													   }
												   ],
												   isDisabled: (button: DynamicButtonRegistration,
																   injector: Injector,
																   component?: CsButtonBarComponent) => {
																const pageComponent = component.currentPageComponent as unknown as DashboardPanelComponentBase<DataDescribed<any>> ;
													   const buttonBarQuery = injector.get(BottomBarQuery);
													   
													   const pageComponentValid = pageComponent && typeof pageComponent.isValid === 'function'
														   ? pageComponent.isValid()
														   : true;
													   
													   const reasonFieldInvalid = component.hasInputOptions && (component.reasonField?.invalid
														   || (buttonBarQuery.getValue().inputRequired && component.reasonField?.pristine));
													   
													   return !pageComponentValid || reasonFieldInvalid;
												   },
												   buttonsStates: [
													   {
														   from:              'save',
														   to:                'save',
														   executeTransition: (button: DynamicButtonRegistration,
																			   injector: Injector,
																			   pageComponent: DashboardPanelComponentBase<DataDescribed<any>>) => {

															   const buttonBarQuery                   = injector.get(BottomBarQuery);
															   const bottomBarService = injector.get(BottomBarService);
															   const auditEntry: AuditTrailAuditEntry = {
																   message: buttonBarQuery.getValue().inputValue
															   };
															   const $result                          = pageComponent.save(auditEntry);
															   $result.pipe(tap(WaitingForResponse.new(isLoading => {
																		  button.isLoading = isLoading;
																		  bottomBarService.detectChanges();
																	  })))
																	  .subscribe(value => {

																	  });
														   }
													   }
												   ]
											   }));

		this.addButton(DynamicButtonRegistration.createClientButton({
																		buttonId:      'Cancel',
																		buttons:       [
																			{
																				label:     'Cancel',
																				name:      'cancel',
																				btnClass:  'btn--quaternary btn-md m-0 mr-2',
																				iconClass: 'mdi mdi-close'
																			}
																		],
																		buttonsStates: [
																			{
																				from:              'cancel',
																				to:                'cancel',
																				executeTransition: (button: DynamicButtonRegistration,
																									injector: Injector, pageComponent: DashboardPanelComponentBase<DataDescribed<any>>) => {
																					const bottomBarService = injector.get(BottomBarService);
																					const $result          = pageComponent.cancel();
																					$result.pipe(tap(WaitingForResponse.new(isLoading => {
																							   button.isLoading = isLoading;
																						   })))
																						   .subscribe(value => {
																							   bottomBarService.requestAction.next(
																								   {action: BottomBarRequestActions.RESET_BAR});
																						   });

																				}
																			}
																		]
																	}));
	}

}
